import React, { useCallback } from 'react';

import { FormField } from '@gogame/form';

import { loadSubTypes } from 'scenes/Influencers/InfluencersCampaigns/sources/fields';

import { COST_MODEL, COST_MODEL_ID, SUB_TYPE } from '../constants';

export default function Events({ disabled }) {
  const handleValidation = useCallback((value) => {
    if (!value) {
      return 'Events is required';
    }
  }, []);

  return (
    <FormField.Select
      label={'Events'}
      padding={0}
      name={SUB_TYPE}
      depends={[`${COST_MODEL}.${COST_MODEL_ID}`]}
      source={loadSubTypes}
      required={true}
      lazy={true}
      validate={handleValidation}
      disabled={disabled}
    />
  );
}
